export enum UploadContentType {
  generalContent = 'GeneralContent',
  cctv = 'Cctv',
  deviceBackup = 'DeviceBackup'
}